import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../utils/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import datascienceandai from '../../images/datascienceandai.png';

import './MyTrainingVideos.css';

const MyTrainingVideos = () => {
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEnrolledVideos = async () => {
      try {
        setLoading(true);
        setError(null);
        const userEmail = localStorage.getItem('userEmail');
        if (!userEmail) {
          setError('Please log in to view your training videos');
          setLoading(false);
          return;
        }

        const data = await apiFetch(
          `${window._env_.API_BASE_URL}/training-videos/my-videos?user_email=${encodeURIComponent(userEmail)}`
        );
        setVideos(data || []);
      } catch (err) {
        console.error('Error fetching enrolled training videos:', err);
        setError(err.message || 'Failed to load training videos');
        setVideos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEnrolledVideos();
  }, []);

  const handleVideoClick = (video) => {
    const deptName = encodeURIComponent(video.department_name);
    navigate(`/${deptName}/${video.video_id}/training-videos`);
  };

  const handleUnenroll = async (e, video) => {
    e.stopPropagation(); // Prevent card click

    try {
      const userEmail = localStorage.getItem('userEmail');
      if (!userEmail) {
        toast.error('Please log in to unenroll from training videos');
        return;
      }

      await apiFetch(
        `${window._env_.API_BASE_URL}/training-videos/${video.video_id}/enroll`,
        {
          method: 'DELETE'
        }
      );

      toast.success('User unenrolled successfully');

      // Refresh the videos list
      setVideos(videos.filter(v => v.video_id !== video.video_id));
    } catch (err) {
      console.error('Error unenrolling from training video:', err);
      toast.error(err.message || 'Failed to unenroll from training video');
    }
  };

  if (loading) {
    return (
      <div className="mtv-loading-page">
        <div className="mtv-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mtv-container">
        <h1 className="mtv-title">My Training Videos</h1>
        <div className="mtv-error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="mtv-container">
      <ToastContainer />
      <h1 className="mtv-title">My Training Videos</h1>
      <p className="mtv-subtitle">Continue watching your enrolled training videos</p>

      {videos.length === 0 ? (
        <div className="mtv-empty">
          <p>You haven't enrolled in any training videos yet.</p>
          <p>Browse departments to find training videos to enroll in.</p>
        </div>
      ) : (
        <div className="mtv-grid">
          {videos.map((video) => (
            <div
              key={video.video_id}
              className="mtv-card"
              onClick={() => handleVideoClick(video)}
            >
              <img
                src={video.thumbnail_url && video.thumbnail_url.trim() ? video.thumbnail_url : datascienceandai}
                alt={video.title}
                className="mtv-thumbnail"
                onError={(e) => {
                  if (e.target.src !== datascienceandai) {
                    e.target.src = datascienceandai;
                  }
                }}
              />
              <div className="mtv-info">
                <h3 className="mtv-card-title">{video.title}</h3>
                {video.description && (
                  <p className="mtv-description">{video.description}</p>
                )}
                <div className="mtv-meta">
                  {video.duration && (
                    <span className="mtv-duration">⏱ {video.duration}</span>
                  )}
                  {video.department_name && (
                    <span className="mtv-department">{video.department_name}</span>
                  )}
                </div>
                {video.enrollment_date && (
                  <span className="mtv-enrollment-date">
                    Enrolled: {new Date(video.enrollment_date).toLocaleDateString()}
                  </span>
                )}
              </div>
              <div className="mtv-actions">
                <button className="mtv-watch-btn">Watch Video</button>
                <button
                  className="mtv-unenroll-btn"
                  onClick={(e) => handleUnenroll(e, video)}
                >
                  Unenroll
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyTrainingVideos;

